"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EContentOrder = void 0;
var EContentOrder;
(function (EContentOrder) {
  /** @deprecated use date_asc/date_desc */
  EContentOrder["creation_date"] = "date_asc";
  EContentOrder["date_asc"] = "date_asc";
  EContentOrder["date_desc"] = "date_desc";
  EContentOrder["updated_asc"] = "updated_asc";
  EContentOrder["updated_desc"] = "updated_desc";
  /** популярность с автоподбором */
  EContentOrder["popularity"] = "popularity";
  EContentOrder["popularity_week"] = "popularity_week";
  EContentOrder["popularity_year"] = "popularity_year";
  EContentOrder["viewed_asc"] = "viewed_asc";
  EContentOrder["viewed_desc"] = "viewed_desc";
  EContentOrder["special"] = "special";
})(EContentOrder = exports.EContentOrder || (exports.EContentOrder = {}));
